import { useFormikContext } from "formik";
import React from "react";
import EmploymentType from "../../../../common/interfaces/enums/EmploymentType";
import ProductType from "../../../../common/interfaces/enums/ProductType";
import useSettingsValidation from "../../../hooks/useSettingsValidation";
import { IQuoteSettings } from "../../../interfaces/form/IQuoteSettings";
import { calculateMaxIncomeMonthlyCover } from "../../../../common/shared/productHelpers";
import Dropdown from "../../../../common/components/Forms/Dropdown/Dropdown";
import Input from "../../../../common/components/Forms/Input/Input";
import Occupation from "../../../../common/components/Forms/Occupation/Occupation";
import { IClientSettingsBoxProduct } from "../ClientSettingsBox/ClientSettingsBox";

const employmentOptions = [
    { value: EmploymentType.Employed, label: "Employed" },
    {
        value: EmploymentType.SelfEmployedOverThreeYears,
        label: "Self-employed (over 3 years)"
    },
    {
        value: EmploymentType.SelfEmployedUnderThreeYears,
        label: "Self-employed (under 3 years)"
    }
];

const ClientSettingsBoxOccupation: React.FC<IClientSettingsBoxProduct> = ({
    client,
    name
}) => {
    const { handleChange, handleBlur, setFieldValue, setFieldTouched } = useFormikContext<
        IQuoteSettings
    >();

    const { getFormikError } = useSettingsValidation();

    return (
        <React.Fragment>
            <Occupation
                id={`${name}.occupation.name`}
                title={"Occupation"}
                initialValue={{
                    label: client.occupation?.name,
                    value: client.occupation?.class
                }}
                onSelect={(e) => {
                    setFieldValue(`${name}.occupation.name`, e.label);
                    setFieldValue(`${name}.occupation.class`, e.value);
                }}
                onBlur={(e) => {
                    handleBlur(e);
                    setFieldTouched(`${name}.occupation.class`);
                }}
                hasError={
                    getFormikError(`${name}.occupation.name`) ||
                    getFormikError(`${name}.occupation.class`)
                }
            />

            <Dropdown
                id={`${name}.occupation.employmentType`}
                name={`${name}.occupation.employmentType`}
                selectedOptionId={client.occupation?.employmentType}
                options={employmentOptions}
                onBlur={handleBlur}
                onChange={handleChange}
                hasError={getFormikError(`${name}.occupation.employmentType`)}
            />

            <Input
                name={`${name}.occupation.income`}
                label={`Annual Income`}
                type={`number`}
                placeholder={`Gross amount`}
                value={client.occupation?.income}
                hasCurrency
                onBlur={handleBlur}
                onChange={async (income) => {
                    await setFieldValue(`${name}.occupation.income`, income, true);

                    let monthlyIncomeCover = calculateMaxIncomeMonthlyCover(income);

                    // It can be funky at small values, so if it's low we just don't auto fill.
                    if (monthlyIncomeCover < 100) {
                        monthlyIncomeCover = undefined;
                    }

                    setFieldValue(
                        `${name}.${ProductType.Income}.monthlyCover`,
                        monthlyIncomeCover,
                        false
                    );
                }}
                hasError={getFormikError(`${name}.occupation.income`)}
            />
        </React.Fragment>
    );
};

export default ClientSettingsBoxOccupation;
